import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    Validators
} from '@angular/forms';
import { Client } from 'src/app/domain/models';
import { ClientService } from 'src/app/domain/services/client.service';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { AccountInfo } from '../../models';

@Component({
    selector: 'app-account-setup',
    templateUrl: './account-setup.component.html',
    styleUrls: ['./account-setup.component.scss'],
    standalone: false
})
export class AccountSetupComponent implements OnInit {
    @Output() accountInfo = new EventEmitter<AccountInfo>();
    @Output() back = new EventEmitter<void>();

    formGroup = this._fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        emailOrPhone: [null, Validators.required],
        receivesNotifications: [true, Validators.required],
        agree: [false, Validators.requiredTrue]
    });

    showHelpText = false;
    displayTerms = false;
    displayPrivacy = false;
    client: Client | undefined;

    constructor(
        private readonly _fb: UntypedFormBuilder,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private readonly _client: ClientService
    ) {}

    ngOnInit() {
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }

    get firstName(): AbstractControl | null {
        return this.formGroup.get('firstName');
    }

    get lastName(): AbstractControl | null {
        return this.formGroup.get('lastName');
    }

    get emailOrPhone(): AbstractControl | null {
        return this.formGroup.get('emailOrPhone');
    }

    get receivesNotifications(): AbstractControl | null {
        return this.formGroup.get('receivesNotifications');
    }

    get agree(): AbstractControl | null {
        return this.formGroup.get('agree');
    }

    onSubmit(e: any): void {
        if (this.formGroup.valid) {
            this.accountInfo.next({
                firstName: this.firstName?.value,
                lastName: this.lastName?.value,
                emailOrPhoneNumber: this.emailOrPhone?.value,
                receivesNotifications: this.receivesNotifications?.value,
                acceptedPrivacyPolicy: this.agree?.value
            });
        }
    }

    goBack(): void {
        this.back.next();
    }

    displayInfo(window: string): void {
        this.displayTerms = this.displayPrivacy = false;
        if (window == 'terms') {
            this.displayTerms = true;
        } else {
            this.displayPrivacy = true;
        }
        this.showHelpText = true;
    }

    goBackPrevious(): void {
        this.showHelpText = !this.showHelpText;
    }
}
